import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { SvgIconProps } from './SvgIcon.types';

export const AdvancedSearchIcon = memo(({ className, fontSize = 120 }: SvgIconProps) => (
  <SvgIcon
    className={className}
    width="116"
    height="115"
    viewBox="0 0 116 115"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fontSize, fill: 'none' }}
  >
    <path
      d="M46.5403 69.0061C60.1382 69.0061 71.1615 57.9683 71.1615 44.3526C71.1615 30.7368 60.1382 19.699 46.5403 19.699C32.9425 19.699 21.9192 30.7368 21.9192 44.3526C21.9192 57.9683 32.9425 69.0061 46.5403 69.0061Z"
      fill="#E8EFEA"
    />
    <path
      d="M113.488 102.017L83.2634 71.752C88.1519 64.7679 91.0134 56.2316 91.0134 47.0985C91.0134 23.2209 71.6384 3.76071 47.7327 3.76071C23.8865 3.76071 4.4519 23.1612 4.4519 47.0388C4.4519 70.9163 23.8269 90.3765 47.7327 90.3765C57.0327 90.3765 65.6173 87.3918 72.7115 82.4372L102.937 112.642C104.367 114.075 106.215 114.851 108.242 114.851C110.269 114.851 112.117 114.075 113.548 112.642C114.979 111.21 115.754 109.359 115.754 107.33C115.694 105.3 114.919 103.449 113.488 102.017ZM47.7327 81.0643C29.0134 81.0643 13.8115 65.8423 13.8115 47.0985C13.8115 28.3546 29.0134 13.1327 47.7327 13.1327C66.4519 13.1327 81.6538 28.3546 81.6538 47.0985C81.6538 65.8423 66.4519 81.0643 47.7327 81.0643Z"
      fill="#F1CAA4"
    />
    <path
      d="M44.6923 86.5561C68.0688 86.5561 87.0192 67.5808 87.0192 44.1735C87.0192 20.7662 68.0688 1.79082 44.6923 1.79082C21.3158 1.79082 2.36536 20.7662 2.36536 44.1735C2.36536 67.5808 21.3158 86.5561 44.6923 86.5561Z"
      stroke="#E87524"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.6923 77.2439C62.9325 77.2439 77.7192 62.4378 77.7192 44.1735C77.7192 25.9092 62.9325 11.1031 44.6923 11.1031C26.452 11.1031 11.6653 25.9092 11.6653 44.1735C11.6653 62.4378 26.452 77.2439 44.6923 77.2439Z"
      stroke="#E87524"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.6923 19.699C55.7807 19.699 65.2 27.101 68.1211 37.249"
      stroke="#226937"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M88.9865 78.9153L79.6269 88.2276"
      stroke="#226937"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M69.3731 43.099C69.8669 43.099 70.2673 42.6981 70.2673 42.2036C70.2673 41.7091 69.8669 41.3082 69.3731 41.3082C68.8792 41.3082 68.4788 41.7091 68.4788 42.2036C68.4788 42.6981 68.8792 43.099 69.3731 43.099Z"
      fill="#026A37"
    />
    <path
      d="M79.0903 69.0061L109.852 99.8082C112.415 102.375 112.415 106.554 109.852 109.18C107.288 111.747 103.115 111.747 100.492 109.18L69.7903 78.4377"
      stroke="#E87524"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
